













import { Vue, Prop, Component } from 'vue-property-decorator';

import ProductCount from '@/components/Molecules/Input/ProductCount.vue';

@Component({
  components: {
    ProductCount,
  },
})
export default class OptionInputArea extends Vue {
  @Prop() payload!: { [key: string]: string };
  @Prop() namespace!: string;
  @Prop() isDuplicateNotPossible!: boolean;
  @Prop() planCount!: number;
  @Prop() index!: number;
  count = 0;

  get groupCount(): number {
    return this.$store.getters[`${this.namespace}/count`]({
      stateKey: 'options',
      carrier: this.payload.carrier,
      simType: this.payload.simType,
      groupId: this.payload.groupId,
    });
  }

  get maxValue(): number {
    if (this.isDuplicateNotPossible) {
      const margin = this.planCount - this.groupCount;
      return this.count + margin;
    } else {
      return this.planCount;
    }
  }

  get validateRules(): string {
    return `max_value:${this.maxValue}`;
  }

  updateCount(count: number) {
    this.count = count;
    this.$emit('updateCount', { index: this.index, count: count });
  }
}
